import { styled, Typography, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import { fluidSize } from '@rumblefish/ui/src/theme/rumblefish23Theme/utils';

export const StyledSection = styled(Section)({});
export const JobPostSectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  width: '100%',
  gap: theme.spacing(6),
  padding: theme.spacing(5, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.greyBackgroundColor?.SURFACE,
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const JobPostListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'stretch',
  width: '100%',
  gap: theme.spacing(10),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

export const JobPostListColumn = styled('div')<{
  left?: boolean;
  fullWidth?: boolean;
}>(({ left = false, fullWidth = false, theme }) => ({
  display: 'flex',
  flexBasis: left ? '30%' : fullWidth ? '100%' : '70%',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  width: '100%',
  gap: theme.spacing(2),
}));

export const StyledList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  marginBlock: 0,
  gap: theme.spacing(2),
}));

export const StyledListItem = styled('li')(({ theme }) => ({
  lineHeight: 1.1,
  fontSize: fluidSize({ minSize: 18, maxSize: 24 }),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  listStyleType: 'disc',
  color: theme.palette.greyBackgroundColor?.SURFACE,
  '&::before': {
    content: '"•"',
    color: theme.palette.greyBackgroundColor?.SURFACE,
    lineHeight: 1.1,
    fontSize: fluidSize({ minSize: 18, maxSize: 24 }),
  },
}));
